import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "@/constants/campaign";

const sections = [
  {
    title: "हम कौन सी जानकारी एकत्र करते हैं",
    body: "समर्थक फॉर्म के माध्यम से हम केवल आपका नाम, मोबाइल नंबर और जिला एकत्र करते हैं। इसके अलावा कोई व्यक्तिगत जानकारी नहीं ली जाती।",
  },
  {
    title: "जानकारी का उपयोग",
    body: "आपकी जानकारी का उपयोग केवल भाजपा की अर्चना अभियान से संबंधित संचार — जैसे अभियान की गतिविधियों, कार्यक्रमों और अपडेट की जानकारी — के लिए किया जाएगा।",
  },
  {
    title: "डेटा सुरक्षा",
    body: "आपका डेटा सुरक्षित सर्वर पर संग्रहीत किया जाता है। हम आपकी जानकारी की सुरक्षा के लिए उचित तकनीकी और संगठनात्मक उपाय अपनाते हैं।",
  },
  {
    title: "तीसरे पक्ष के साथ साझाकरण",
    body: "हम आपकी जानकारी किसी भी तीसरे पक्ष को बेचते, किराए पर देते या साझा नहीं करते हैं।",
  },
  {
    title: "आपके अधिकार",
    body: "आप कभी भी अपनी जानकारी हटवाने या सुधारने का अनुरोध कर सकते हैं। इसके लिए अभियान टीम से संपर्क करें।",
  },
  {
    title: "संपर्क",
    body: "गोपनीयता संबंधी किसी भी प्रश्न के लिए अभियान टीम से संपर्क करें: admin@bjpkiarchana.com",
  },
];

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-policy-page" className="min-h-screen bg-[#FFF5ED]">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="privacy-logo" className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="भाजपा की अर्चना लोगो"
              className="h-11 w-11 rounded-full object-cover border border-slate-200"
            />
            <span className="font-heading text-xl md:text-2xl font-semibold text-slate-900">
              भाजपा की <span className="text-[#FF9933]">अर्चना</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-[#FF9933] transition-colors duration-300"
          >
            <ArrowLeft size={16} /> होम पर वापस जाएँ
          </Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16">
        <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
          गोपनीयता नीति (Privacy Policy)
        </h1>
        <p className="text-sm text-slate-500 mt-2">bjpkiarchana.com — भाजपा की अर्चना अभियान</p>

        <p className="text-base md:text-lg leading-relaxed text-slate-700 mt-6">
          हम आपकी निजता का सम्मान करते हैं। इस वेबसाइट पर दी गई जानकारी (नाम, फोन नंबर, जिला)
          का उपयोग केवल अभियान से संबंधित संचार के लिए किया जाएगा। आपका डेटा सुरक्षित है और
          इसे किसी तीसरे पक्ष के साथ साझा नहीं किया जाएगा।
        </p>

        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.title} className="bg-white rounded-lg border border-slate-100 shadow-sm p-6">
              <h2 className="font-heading text-xl md:text-2xl font-semibold text-slate-800">
                {s.title}
              </h2>
              <p className="text-base leading-relaxed text-slate-700 mt-2">{s.body}</p>
            </section>
          ))}
        </div>

        <p className="text-xs text-slate-500 mt-10 leading-relaxed">
          अंतिम अपडेट: सितंबर 2026 • यह पेज अर्चना गुप्ता जी के समर्थकों (Fan Page)
          द्वारा प्रबंधित है।
        </p>
      </div>
    </main>
  );
}
